import React from 'react';
import { Calendar, MapPin, Users } from 'lucide-react';

// --- EventCard Component ---
// Moved out for clarity and better structure. All hover logic is now in CSS.
const EventCard = ({ event }) => (
  <div style={styles.eventCard} data-component="event-card">
    <div style={styles.eventCardHeader}>
      <span style={{ ...styles.eventType, backgroundColor: event.typeColor }}>
        {event.type}
      </span>
      <Calendar size={20} color="#9CA3AF" />
    </div>

    <h3 style={styles.eventTitle}>{event.title}</h3>

    <p style={styles.eventDescription}>{event.description}</p>

    <div style={styles.eventDetails}>
      <div style={styles.eventDetailItem}>
        <Calendar size={16} />
        <span>{event.date}</span>
      </div>
      <div style={styles.eventDetailItem}>
        <MapPin size={16} />
        <span>{event.location}</span>
      </div>
    </div>
  </div>
);

// --- Main UpcomingEvents Component ---
const UpcomingEvents = () => {
  const events = [
    { type: 'Education', title: 'Global AI Society Conference', description: 'Academic Odyssey: AI, Leadership & the Future of Global Education', date: 'Oct 18-24, 2025', location: '🇨🇭 Zurich, Switzerland', typeColor: '#3B82F6' },
    { type: 'Leadership', title: 'AI Leadership Forum', description: 'AI Leadership in the Digital Age - Strategic Integration for the Business Growth', date: 'Oct 27-31, 2025', location: '🇬🇧 London, United Kingdom', typeColor: '#10B981' },
    { type: 'Entrepreneurship', title: 'AI Entrepreneurship Conference', description: 'AI Entrepreneurship in the Digital Age - Ideation to Execution with AI', date: 'Nov 3-7, 2025', location: '🇺🇸 Washington DC, USA', typeColor: '#8B5CF6' }
  ];

  return (
    <div style={styles.container} data-component="container">
      <style>
        {`
          /* --- Hover Effects --- */
          [data-component="event-card"]:hover {
            transform: translateY(-4px) !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
            border-color: #4B5563 !important;
          }
          [data-component="register-button"]:hover {
            background-color: #4B5563 !important;
            border-color: #6B7280 !important;
          }

          /* --- Responsive Design --- */
          @media (max-width: 768px) {
            [data-component="container"] {
              padding: 60px 10px !important;
            }
            [data-component="title"] {
              font-size: 38px !important;
            }
            [data-component="subtitle"] {
              font-size: 16px !important;
            }
            [data-component="grid"] {
              grid-template-columns: 1fr !important;
            }
            [data-component="event-card"] {
              width: 95% !important;
              margin: 0 auto !important;
            }
          }
        `}
      </style>
      <div style={styles.content}>
        <div style={styles.header}>
          <h1 style={styles.title} data-component="title">Upcoming Events</h1>
          <p style={styles.subtitle} data-component="subtitle">
            Join us at conferences, workshops, and symposiums shaping the future of AI education.
          </p>
        </div>

        <div style={styles.grid} data-component="grid">
          {events.map((event, index) => (
            <EventCard key={index} event={event} />
          ))}
        </div>
      </div>
    </div>
  );
};

// --- Styles Object ---
const styles = {
  container: {
    backgroundColor: '#0a0a0a',
    minHeight: '100vh',
    padding: '80px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  header: {
    textAlign: 'center',
    marginBottom: '60px'
  },
  title: {
    color: 'white',
    fontSize: '48px',
    fontWeight: '800',
    marginBottom: '20px',
    letterSpacing: '-0.02em'
  },
  subtitle: {
    color: '#9CA3AF',
    fontSize: '18px',
    lineHeight: '1.6',
    maxWidth: '600px',
    margin: '0 auto'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '32px',
    alignItems: 'stretch'
  },
  eventCard: {
    backgroundColor: '#1F2937',
    border: '1px solid #374151',
    borderRadius: '12px',
    padding: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },
  eventCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px'
  },
  eventType: {
    color: 'white',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'capitalize'
  },
  eventTitle: {
    color: 'white',
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '16px',
    lineHeight: '1.3'
  },
  eventDescription: {
    color: '#9CA3AF',
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '24px',
    flex: 1
  },
  eventDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px'
  },
  eventDetailItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#9CA3AF',
    fontSize: '14px'
  },
  registerButton: {
    backgroundColor: '#374151',
    color: 'white',
    border: '1px solid #4B5563',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    width: '100%'
  }
};

export default UpcomingEvents;